// src/lib/remoteOptions/index.ts
import { carsOptions } from './cars';
import { clientsOptions } from './clients';
import { quotationsOptions } from './quotations';
import { activitiesOptions } from './activities';
import { opportunitiesOptions } from './opportunities';
import { salesOptions } from './sales';

export const remoteOptionsRegistry: Record<string, (query?: string) => Promise<any[]>> = {
  ...carsOptions,
  ...clientsOptions,
  ...quotationsOptions,
  ...activitiesOptions,
  ...opportunitiesOptions,
  ...salesOptions,
};
